<template>
  <van-overlay :show="true" z-index="300">
    <div :class="$style.box">
      <div>
        <img :class="$style.text" :src="signImg" />
        <img :class="$style.close" :src="closeImg" @click="closeMask" />
        <div :class="$style.sign">
          <div :class="$style.photo" @click="changeAvatar">
            <img v-if="form.image" :src="form.image" />
            <img v-else :src="photoImg" />
            <img :src="cameraImg" />
          </div>
          <div :class="$style.name">
            <div>
              <img :src="nameImg" />
              <van-field
                v-model="form.forum_name"
                maxlength="8"
                rows="1"
                placeholder="请输入昵称(最多8个字)"
              >
              </van-field>
            </div>
            <img :class="$style.tips" :src="tipsImg" />
          </div>
          <img :src="submitImg" @click="submit" />
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Overlay, Field, Toast } from "vant";
import UploadMixin from "@/mixins/uploadImage";
import { setAvatar, modifyUserInfo, getUserInfo } from '@/api/account';
import { reportData } from '@/api/report.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from "@/config/index.js";
import { getDevice } from '@/utils/getdevice.js';
export default {
  components: {
    VanOverlay: Overlay,
    VanField: Field
  },
  mixins: [UploadMixin],
  data() {
    return {
      signImg: `${CDN_URL}/register/text.png`, // 注册小图标
      closeImg: `${CDN_URL}/register/close.png`, // 关闭小图标
      photoImg: `${CDN_URL}/register/photo.png`, // 头像背景
      cameraImg: `${CDN_URL}/register/camera.png`,
      tipsImg: `${CDN_URL}/register/tips.png`,
      submitImg: `${CDN_URL}/register/submit.png`,
      nameImg: `${CDN_URL}/register/name.png`,
      form: {
        sex: '',
        image: '',
        forum_name: '',
        motto: '',
        type: '', // 设备类型
      },
      submitFlag: false, // 防重复点击
    };
  },
  created() {
    this.initForm()
  },
  mounted() {
    reportData({
      type: 8
    })
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG'
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    // 初始化论坛头像昵称
    async initForm() {
      const r = await getUserInfo()
      let deviceType = 3 // 设备类型,默认是电脑
      if (getDevice().Mobile) {
        deviceType = 1
      }
      if (getDevice().iPad) {
        deviceType = 2
      }
      Object.assign(this.form, {
        sex: r.data.sex || 1,
        image: r.data.images || this.photoImg,
        forum_name: r.data.wechat_name || '黑喵用户',
        motto: '该用户很高冷，还没有个性签名~~',
        type: deviceType,
      })
    },
    closeMask() {
      this.CHANGE_REGISTER_DIALOG(false)
    },
    async setAvatar(src) {
      this.form.image = src
    },
    // 修改头像
    changeAvatar() {
      this.uploadImage(1, true)
    },
    // 提交表单
    async submit() {
      if (this.submitFlag) return;
      this.submitFlag = true;
      let hasRegister = sessionStorage.getItem("hasRegisterDia");
      if (hasRegister) {
        Toast("您已完成账号注册，请勿重复提交。")
        return;
      }
      if (!this.form.image) {
        Toast("请选择头像")
        return
      }
      if (!this.form.forum_name) {
        Toast("请输入昵称")
        return
      }
      try {
        const r = await modifyUserInfo(this.form);
        this.getUserInfo();
        sessionStorage.setItem("hasRegisterDia", true);
        Toast("设置成功");
        this.CHANGE_REGISTER_DIALOG(false)
      } catch (error) {
        Toast(error.message)
      } finally {
        this.submitFlag = false;
      }
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable.scss';
.box {
  width: 100vw;
  height: 100vh;
  background-image: url('#{$cdn-url-hm}/register/bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 350px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    position: relative;
    width: 350px;
    height: 360px;
    .text {
      position: absolute;
      top: 0px;
      left: 10px;
      width: 40px;
    }
    .close {
      position: absolute;
      top: -3px;
      right: 10px;
      width: 30px;
    }
    .sign {
      padding-top: 30px;
      width: 350px;
      height: 350px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .photo {
        position: relative;
        > img:first-child {
          width: 90px;
          height: 90px;
          display: block;
          border-radius: 50%;
        }
        > img:last-child {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 26px;
          height: 26px;
        }
      }
      .name {
        display: flex;
        flex-direction: column;
        align-items: center;
        > div {
          display: flex;
          align-items: center;
          justify-content: center;
          > img {
            width: 35%;
          }
        }
        > img {
          margin-top: 10px;
          width: 60%;
        }
        :global {
          .van-cell {
            padding-left: 0;
          }
          .van-field {
            width: 160px;
            height: 30px;
            padding: 0px;
            border: 1.5px solid rgba(253, 146, 90, 0.7);
            border-radius: 4px;
            font-size: 13px;
            display: inline-block;
            background-color: rgba(0, 0, 0, 0);
            .van-field__value {
              padding-left: 10px;
              height: 30px;
              line-height: 30px;
            }
          }
          .van-field__body {
            > input {
              color: rgba(36, 35, 35, 0.7);
              font-weight: 700;
            }
          }
        }
      }
      > img {
        width: 60%;
      }
    }
  }
}
</style>